
import { useState, useEffect } from 'react';
import { TrackDownload } from '@/lib/types';
import { toast } from "sonner";
import { useTrackNotification } from './useTrackNotification';
import { supabase } from '@/integrations/supabase/client';

export const useSuccessModal = (scrollRef: React.RefObject<HTMLDivElement>) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [newTrack, setNewTrack] = useState<TrackDownload | null>(null);
  const [isSendingNotification, setIsSendingNotification] = useState(false);
  const { sendTrackNotificationEmail } = useTrackNotification();
  
  const handleSuccess = async (upload: TrackDownload) => {
    setNewTrack(upload);
    setShowSuccessModal(true);
    
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    
    toast.success("Track uploaded successfully!", {
      position: "bottom-center"
    });
    
    if (upload && upload.id) {
      console.log('🎵 New track uploaded, sending notification:', { 
        id: upload.id, 
        trackName: upload.trackName 
      });
      
      // Get user's email from the current session
      const { data: sessionData } = await supabase.auth.getSession();
      const userEmail = sessionData.session?.user?.email;
      
      // Send email notification
      setIsSendingNotification(true);
      try {
        const result = await sendTrackNotificationEmail(upload.id, userEmail);
        console.log('📧 Notification result:', result);
        
        if (!result.success) {
          console.warn('⚠️ Notification wasn\'t sent successfully. Check Edge Function logs in Supabase dashboard.');
        }
      } catch (error) {
        console.error('❌ Failed to send notification:', error);
      } finally {
        setIsSendingNotification(false);
      }
    } else {
      console.error('❌ Cannot send notification - missing track data:', {
        id: upload?.id,
        trackName: upload?.trackName
      });
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    setNewTrack(null);
  };

  return {
    showSuccessModal,
    newTrack,
    isSendingNotification,
    handleSuccess,
    handleCloseModal
  };
};
